import React, { useState } from 'react';
import NavBar from './components/NavBar';

import './global.css';
import Slide from './components/Slide';
import Content from './components/Content';
import Footer from './components/Footer';


function App() {
  const [link, setLink] = useState('');
  return (
    <>
      <header>
        <NavBar handleAnchor={(e) => setLink(e)} />
        < Slide />
      </header>
      <main>
        <Content anchor={link} />
      </main>

      <footer>
        <Footer />
      </footer>
    </>
  );
}

export default App;
